import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=21c06c1f&"
import script from "./BuildingInfo.vue?vue&type=script&lang=js&"
export * from "./BuildingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildingInfo.vue?vue&type=style&index=0&id=21c06c1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports